import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FC } from 'react';
import styles from './style.m.less';

const ARROW_POSITIONS: ArrowPosition[] = [
    'top',
    'bottom',
    'left',
    'right',
    'top-start',
    'top-end',
    'bottom-start',
    'bottom-end',
];

export type ArrowPosition =
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end';

type Props = {
    position: ArrowPosition;
};

const Arrow: FC<Props> = ({ position, ...otherProps }) => (
    <div {...otherProps} className={classNames(styles.arrow, styles[position])} />
);

Arrow.propTypes = {
    position: PropTypes.oneOf(ARROW_POSITIONS).isRequired,
};

export default Arrow;
